<template>
  <div>
    <div class="row">
      <h3 class="card-title" style="text-decoration:underline;">
        Στοιχεία υπαλλήλου
      </h3>
      <div v-for="(card, index) in cards" :key="index">
        <div class="card">
            <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                    <label class="mt-3">Εργοδότης</label>
                    <multiselect
                        placeholder="Επιλογή Τομέα"
                        :options="trainingOptions"
                        v-model="card.selectedValue"
                        selectLabel="Eπιλογή Τομέα"
                        selectedLabel="Επιλέχθηκε"
                        deselectLabel="Αποεπιλογή"
                        :max-height="150"
                    ></multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="mt-3">
                    <label>Ημερομηνία Αναγνώρισης</label>
                    <input
                        type="date"
                        class="form-control"
                        v-model="card.date"
                        placeholder="DD-MM-YYYY"
                        format="DD-MM-YYYY"
                        autocomplete="off"
                    />
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="mt-5">Διάρκεια Προυπηρεσίας:</label>
                </div>
                <div class="col-md-1">
                    <label class="mt-3">Έτη</label>
                    <b-form-input
                    :id="'years-' + card.id"
                    v-model="card.years"
                    type="text"
                    autocomplete="off"
                    ></b-form-input>
                </div>
                <div class="col-md-1">
                    <label class="mt-3">Μήνες</label>
                    <b-form-input
                    :id="'months-' + card.id"
                    v-model="card.months"
                    type="text"
                    autocomplete="off"
                    ></b-form-input>
                </div>
                <div class="col-md-1">
                    <label class="mt-3">Ημέρες</label>
                    <b-form-input
                    :id="'days-' + card.id"
                    v-model="card.days"
                    type="text"
                    autocomplete="off"
                    ></b-form-input>
                </div>
                <div class="col-md-1 mt-5">
                    <i
                        class="bx bx-plus-medical"
                        style="color:green;cursor:pointer;"
                        @click="addCard()"
                        >Προσθήκη
                    </i>
                </div>
                <div class="col-md-1 mt-5">
                    <i
                        class="bx bx-trash"
                        style="color:red;cursor:pointer;"
                        @click="removeCard(card.id)"
                        >Αφαίρεση
                    </i>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: "Ergasiaka",
  components: {
    Multiselect,
  },

  data() {
    return {
      familyStatusSelected: "",

      familyStatusOptions: [
        "Ανύπαντρος/η",
        "Έγγαμος/η",
        "Διαζευγμένος/η",
        "Χήρος/α",
      ],
      trainingOptions: ["Ιδιωτικός Τομέας", "Δημόσιος Τομέας"],
      selectedValue: "",
      grades: ["Α", "Β", "Γ", "Δ", "Ε "],
      gradeSelected: "",
      mkRangeOptions: [
        ...Array(19)
          .fill(1)
          .map((x, y) => x + y),
      ],
      mkSelected: "",
      cards: [
        {
            id: 1,
            selectedValue: "",
            date: "",
            years: "",
            months: "",
            days: ""
        }
        ],
    };
  },
  methods: {
    addCard() {
        this.cards.push({
        id: this.cards.length + 1,
        selectedValue: "",
        date: "",
        years: "",
        months: "",
        days: ""
        });
    },
    removeCard(id) {
        const index = this.cards.findIndex(card => card.id === id);
        if (index > -1) {
            this.cards.splice(index, 1);
        }
        if (Object(this.cards).length == 0) {
          this.addCard()
        }
    }
  }
};
</script>
